<template>
  <div v-if="calculatedTotalPages > 0" class="pager">
    <button
      class="prev page"
      v-if="calculatedTotalPages != 1"
      @click="onPageChanged(1)"
    >
      <base-icon class="prev" name="two-arrows-chevron-left" />
    </button>
    <button
      class="prev page"
      v-if="calculatedTotalPages != 1"
      @click="onPageChanged(pageNumber - 1)"
    >
      <base-icon class="prev" name="arrows-chevron-left" />
    </button>
    <div class="pages-conteiner">
      <button
        :key="page.i"
        v-for="page in pages"
        class="page"
        @click="onPageChanged(page.i)"
        :class="page.i === pageNumber ? 'active' : null"
        :id="`paginationButton${page.title}`"
      >
        {{ page.i }}
      </button>
    </div>
    <button
      class="next page"
      v-if="calculatedTotalPages != 1"
      @click="onPageChanged(pageNumber + 1)"
    >
      <base-icon class="next" name="arrows-chevron-right" />
    </button>
    <button
      class="next page"
      v-if="calculatedTotalPages != 1"
      @click="onPageChanged(calculatedTotalPages)"
    >
      <base-icon class="next" name="two-arrows-chevron-right" />
    </button>
  </div>
</template>

<script>
import BaseIcon from "./BaseIcon.vue";

export default {
  components: { BaseIcon },
  name: "RepresReportsPager",
  data() {
    return {
      pages: [],
    };
  },
  props: {
    pageNumber: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
  },
  computed: {
    calculatedTotalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
  },
  watch: {
    pageNumber(val) {
      this.loadPageData(val);
    },
    calculatedTotalPages() {
      this.loadPageData(this.pageNumber);
    },
  },
  mounted() {
    this.loadPageData(this.pageNumber);
  },
  methods: {
    loadPageData(val) {
      this.pages = [];
      let counter = 1;
      const determineIndex = Math.abs(val - 2) === 0 ? 1 : Math.abs(val - 2);
      for (let i = determineIndex; i <= this.calculatedTotalPages; i++) {
        if (counter <= 4) {
          this.pushPage(i);
        } else if (counter === 5) {
          const page = {
            i: "...",
            title: "page_three_dots",
          };
          this.pages.push(page);
        } else if (
          i === this.calculatedTotalPages ||
          i === this.calculatedTotalPages - 1
        ) {
          this.pushPage(i);
        }
        counter++;
      }
    },
    onPageChanged(pageNumber) {
      if (
        this.calculatedTotalPages > 1 &&
        pageNumber <= this.calculatedTotalPages
      ) {
        this.$emit("onPageChanged", pageNumber);
      }
    },
    pushPage(i) {
      const page = {
        i,
        title: `page_${i}`,
      };
      this.pages.push(page);
    },
  },
};
</script>

<style lang="scss" scoped>
.pager {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page {
  width: max-content;
  background-color: white;
  border-radius: 3px;
  border: solid 1px var(--color-primary-tint-second);
  cursor: pointer;
  color: var(--color-primary-silver-metallic);
  margin-right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 768px) {
    width: 29px;
    margin-right: 3px;
  }
  @media screen and (max-width: 375px) {
    width: 26px;
    margin-right: 2px;
  }
}
.pages-conteiner {
  .page {
    display: inline-block;
    font-size: 14px;
    padding: 8px;
    @media screen and (max-width: 768px) {
      padding: 6px 0;
      margin-right: 2px;
      width: 28px;
    }
    @media screen and (max-width: 395px) {
      width: 25px;
      margin-right: 2px;
    }
    @media screen and (max-width: 360px) {
      width: 23px;
      margin-right: 2px;
    }
    &:hover,
    ::v-deep &.active {
      background-color: var(--color-primary-default);
      color: white;
    }
  }
}
</style>
